import axios from "axios";
import { EndPoint } from "./EndPoint";
import { AuthService } from "../auth/AuthService";

const main = EndPoint.HOTEL_MAIN + "/?api=";

export class HotelServices {
  static getHotelList = async (payload: any) => {
    const url = main + EndPoint.HOTEL_LIST;
    try {
      console.log("hotelsearch", JSON.stringify(payload));
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("getHotelList", JSON.stringify(response?.data));
      return response;
    } catch (error) {
      console.error("Error fetching getHotelList:", error);
      throw error;
    }
  };

  static gethoteldetails = async (payload: any) => {
    const url = main + EndPoint.HOTEL_INFO;
    try {
      console.log("getHotelInfo", JSON.stringify(payload));
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("getHotelInfo", JSON.stringify(response?.data));
      return response;
    } catch (error) {
      console.error("Error fetching getHotelList:", error);
      throw error;
    }
  };

  static getRoomDetail = async (payload: any) => {
    const url = main + EndPoint.ROOM_INFO;
    try {
      console.log("getRoomInfo", JSON.stringify(payload));
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      console.log("getRoomInfo", JSON.stringify(response?.data));
      return response;
    } catch (error) {
      console.error("Error fetching getRoomInfo:", error);
      throw error;
    }
  };

  static getHotelFilter = async (payload: any) => {
    const url = main + EndPoint.HOTEL_FILTER;
    try {
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching getRoomInfo:", error);
      throw error;
    }
  };

  static getHotelBooking = async (bookingPayload: any) => {
    const url = main + EndPoint.HOTEL_BOOKING;
    try {
      console.log("getHotelBooking", JSON.stringify(bookingPayload));
      const response = await AuthService.postCryptoRequestWithoutSlash(
        url,
        JSON.stringify(bookingPayload)
      );
      console.log("getHotelBooking", JSON.stringify(response?.data));
      return response;
    } catch (error) {
      console.error("Error fetching getRoomInfo:", error);
      throw error;
    }
  };
}
